<!-- 小-满额有礼统一 -->
<template>
  <div
    class="cardContent"
    :style="{
      backgroundImage: `url(${backgroundImage})`,
    }"
  >
    <div class="cardTop">
      <span class="title">{{ previewData.title || "这是小部件标题" }}</span>
      <span class="time"
        >距结束 <span class="day">xx</span>天 <span class="day">hh</span>:
        <span class="day">mm</span>: <span class="day">ss</span></span
      >
    </div>
    <div class="cardcenter">
      <div class="center-left">
        <div class="awardIconBox">
          <img
            :src="previewData.logo || getLogo(previewData.prizeType)"
            style="width: 100%; height: 100%"
          />
          <span class="awardName">{{
            previewData.prizeName || "奖品名称"
          }}</span>
        </div>
        <span class="awardIndex"> 1/{{ previewData.imgCount }} </span>
      </div>
      <div class="center-right">
        <div class="activity-theme">
          {{ previewData.topic || "活动主题" }}
        </div>
        <div class="prize-count">剩余xxx份</div>
        <div class="condition-text">{{ getConditionText() }}</div>
        <div class="progress-line">
          <div class="progress-bar">
            <div class="progress-fill"></div>
          </div>
          <!-- <div class="progress-dot"></div> -->
        </div>
        <div class="amount-display">
          <span class="bought-amount"
            >已买0{{ getStatisticUnit
            }}<template v-if="previewData.itemLimitCount">且0件</template></span
          >
          <span class="target-amount"
            >满{{ getTargetAmount }}{{ getStatisticUnit
            }}<template v-if="previewData.itemLimitCount"
              >且{{ previewData.itemLimitCount }}件</template
            ></span
          >
        </div>
        <div class="signup-button">
          <span :style="{
            background: cusTemplateJSON.btnColor1 ? `linear-gradient( 33deg, ${cusTemplateJSON.btnColor1} 0%, ${cusTemplateJSON.btnColor2} 100%)` : ''
            }"
          >
            立即报名
          </span>
        </div>
      </div>
    </div>
    <!-- 加购商品信息 -->
    <div class="cart-goods-info" v-if="previewData.cartGoods">
      <div class="cart-goods-title">加购商品:</div>
      <div class="cart-goods-list">
        <div class="cart-goods-item" v-for="(item, index) in previewData.cartGoods.split('\n')" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityCard",
  props: {
    previewData: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    unitName: {
      type: String,
      default: "",
    },
    cusTemplateJSON: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getStatisticUnit() {
      const statisticType = this.previewData.statisticType;
      switch (statisticType) {
        case 0:
          return "元";
        case 1:
          return "件";
        case 3:
          return "笔";
        case 4: // 自定义计量单位
          return this.unitName;
        default:
          return "元"; // 默认显示元
      }
    },
    getTargetAmount() {
      const statisticType = this.previewData.statisticType;
      switch (statisticType) {
        case 0:
          return this.previewData.orderPaymentLimit; // 满额
        case 1:
          return this.previewData.itemLimitCount; // 满件
        case 3:
          return this.previewData.orderLimitCount; // 满笔
        case 4: // 自定义计量单位
          return this.previewData.measureUnitLimitCount; // 自定义计量单位的消费门槛
        default:
          return this.previewData.orderPaymentLimit; // 默认满额
      }
    },
  },
  methods: {
    getConditionText() {
      // 当activityType为46时，根据statisticType判断
      if (this.previewData.activityType === 46) {
        const statisticType = this.previewData.statisticType;
        const orderCountType = this.previewData.orderCountType;
        const orderPaymentLimit = this.previewData.orderPaymentLimit;
        const itemLimitCount = this.previewData.itemLimitCount;
        const orderLimitCount = this.previewData.orderLimitCount;
        const measureUnitLimitCount = this.previewData.measureUnitLimitCount;

        const prefix = orderCountType == 1 ? "累计" : "单笔";

        switch (statisticType) {
          case 0: // 满额
            return `${prefix}满${orderPaymentLimit}元(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 1: // 满件
            return `${prefix}满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 2: // 满额满件
            return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 3: // 满笔
            return `${prefix}满${orderLimitCount}笔(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 4: // 自定义计量单位
            return `${prefix}满${measureUnitLimitCount}${this.getStatisticUnit}`;
          default:
            return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
        }
      } else {
        // 其他活动类型都是满额满件
        const orderCountType = this.previewData.orderCountType;
        const orderPaymentLimit = this.previewData.orderPaymentLimit; // 订单金额
        const itemLimitCount = this.previewData.itemLimitCount; // 商品件数
        // 首单专享礼
        if (this.previewData.activityType === 17) {
          if (!itemLimitCount) {
            return `单笔满${orderPaymentLimit}元`;
          }
          return `单笔满${orderPaymentLimit}元且商品满${itemLimitCount}件`;
        }
        const prefix = orderCountType == 1 ? "累计" : "单笔";
        if (!itemLimitCount) {
          return `${prefix}满${orderPaymentLimit}元`;
        }
        return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件`;
      }
    },
    // 获取图片
    getLogo(prizeType) {
      let logo = "";
      if (prizeType == 1) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_coupon.png";
      } else if (prizeType == 2) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_jd.png";
      } else if (prizeType == 4) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_jf.png";
      } else if (prizeType == 5) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_ecard.png";
      } else if (prizeType == 6) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_iqiyi.png";
      } else if (prizeType == 7) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_plus.png";
      } else {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_hb.png";
      }
      return logo;
    },
  },
  mounted() {
    console.log("--- ~ this.previewData1:---", this.previewData);
  },
};
</script>

<style lang="scss" scoped>
.cardContent {
  position: absolute;
  top: 170px;
  left: 5px;
  width: 100%;
  height: 112px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;

  .cardTop {
    display: flex;
    justify-content: space-between;
    padding: 4px 14px 0px 4px;
    font-size: 8px;

    .title {
      color: #fff;
      width: 65px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .time {
      .day {
        color: #ce2d2f;
        padding: 0px 4px;
        background-color: rgba(255, 255, 255, 0.65);
      }
    }
  }

  .cardcenter {
    display: flex;
    margin-top: 10px;
    padding: 0 8px;

    .center-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;

      .awardIconBox {
        font-size: 8px;
        width: 60px;
        background-color: #fff;
        padding: 5px 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        border-radius: 6px;

        img {
          width: 100%;
          height: 60px;
          border-radius: 6px;
        }
        .awardName {
          // 一行显示
          width: 50px;
          text-align: center;
          line-height: 1.6;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .awardIndex {
        font-size: 8px;
      }
    }

    .center-right {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 0 8px 8px 8px;
      width: 66%;

      .activity-theme {
        color: #333;
        font-size: 12px;
        font-weight: bold;
        text-align: start;
      }

      .prize-count {
        width: 40px;
        background-color: rgba(0, 0, 0, 0.2);
        color: #fff;
        font-size: 6px;
        padding: 2px 4px;
        text-align: center;
        border-radius: 2px;
      }

      .condition-text {
        color: #999;
        font-size: 8px;
        text-align: center;
        line-height: 1.2;
        text-align: start;
      }

      .progress-line {
        display: flex;
        align-items: center;
        margin: 1px 0;

        .progress-bar {
          flex: 1;
          height: 1px;
          background-color: rgba(255, 255, 255, 0.5);
          position: relative;

          .progress-fill {
            width: 50%; // 可以根据实际进度调整
            height: 100%;
            background-color: #000;
            border-radius: 1px;
          }
        }

        .progress-dot {
          width: 4px;
          height: 4px;
          background-color: #000;
          border-radius: 50%;
          margin-left: -8px;
          position: relative;
          z-index: 1;
        }
      }

      .amount-display {
        display: flex;
        justify-content: space-between;
        font-size: 8px;

        .bought-amount {
          color: #333;
        }

        .target-amount {
          color: #333;
        }
      }

      .signup-button {
        margin-top: 4px;
        display: flex;
        justify-content: end;
        align-items: center;
        span {
          background-color: #000;
          color: #fff;
          width: 60px;
          font-size: 8px;
          text-align: center;
          padding: 3px 6px;
          border-radius: 10px;
          cursor: pointer;
        }
      }
    }
  }

  .cart-goods-info {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 4px;
    padding: 10px;
    z-index: 10;

    .cart-goods-title {
      font-size: 12px;
      color: #333;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .cart-goods-list {
      .cart-goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        font-size: 12px;
        color: #333;
      }
    }
  }
}
</style>
